export abstract class Clipper {
    public static write(value: any): Promise<void> {
        if (!value) {
            return Promise.resolve();
        }
        try {
            if (typeof value !== "string") {
                value = value.toString();
            }

            if ((window as any).clipboardData) {
                // IE11
                (window as any).clipboardData.setData("Text", value);
                return Promise.resolve();
            } else if (navigator.clipboard) {
                // Sane browsers
                return navigator.clipboard.writeText(value);
            }
        } catch (ex) {
            console.warn(ex);
        }

        // Complete sh1tshow lol
        return Promise.reject();
    }
}
